export function toFormData(payload: object): FormData {
  const formData = new FormData()

  for (const [key, value] of Object.entries(payload)) {
    append(formData, key, value)
  }

  return formData
}

function append(formData: FormData, key: string, value: unknown): void {
  if (value === null || value === undefined) {
    return
  }

  if (value instanceof Blob) {
    formData.append(key, value, value instanceof File ? value.name : 'file')
  } else if (Array.isArray(value)) {
    value.forEach((item, index) => append(formData, `${key}[${index}]`, item))
  } else if (typeof value === 'object') {
    Object.entries(value).forEach(([subKey, subValue]) =>
      append(formData, `${key}[${subKey}]`, subValue)
    )
  } else if (typeof value === 'boolean') {
    formData.append(key, value ? '1' : '0')
  } else {
    formData.append(key, String(value))
  }
}
